/* eslint-disable camelcase */

/* +---------------------------------------------------------+
 * | NOTE - PLEASE READ THIS!                                |
 * | Before adding new colors, consider using existing ones. |
 * +---------------------------------------------------------+
 */

// Taken from Material Design color palettes (e.g. https://vuetifyjs.com/en/style/colors)
const MATERIAL_COLORS = Object.freeze({
    darkred: '#b71c1c',
    red: '#ef5350',
    pink: '#ec407a',
    purple: '#ab47bc',
    violet: '#7e57c2',
    darkpurple: '#4a148c',
    darkblue: '#01579b',
    indigo: '#5c6bc0',
    lightblue: '#42a5f5',
    cyan: '#00e5ff',
    teal: '#26a69a',
    darkgreen: '#33691e',
    green: '#66bb6a',
    lightgreen: '#9ccc65',
    darklime: '#9e9d24',
    lime: '#d4e157',
    yellow: '#ffee58',
    amber: '#ffca28',
    orange: '#ffa726',
    deepOrange: '#ff7043',
    gray: '#78909c',
    lightgray: '#bdbdbd',
    lightbrown: '#8d6e63',
    brown: '#4e342e'
});


// Color names from http://www.htmlcsscolor.com/color-names-rgb-values

// Will be available as SCSS variables in the form $color_[key]
const cssColors = {
    ci_smalt: '#003399',
    ci_blue_shade0: '#0f277a',
    ci_blue_shade1: '#5067a5',
    ci_blue_shade2: '#8393bc',
    ci_blue_shade3: '#b1bad4',
    ci_blue_shade4: '#d2d6e5',
    ci_blue_shade5: '#edf4fa',

    black: '#000000',
    white: '#ffffff',
    gray_snow: '#fafafa',
    gray_white_smoke: '#f5f5f5',
    gray_whisper: '#e6e6e6',
    gray_gainsboro: '#dddddd',
    gray_very_light: '#cccccc',
    gray_nobel: '#999999',
    gray: '#808080',
    gray_dim: '#666666',
    gray_nero: '#262626',

    green: '#006400',
    green_sushi: '#7fa93a',
    red_very_light: '#ffeaea',

    heatmap_blue: '#0055cc',
    heatmap_green: '#00cc00',
    heatmap_yellow: '#cccc00',

    bootstrap_btn_border_active: '#adadad',
    bootstrap_error_border: '#a94442'
};

// P2P trip colors as requested in DEFECTODM-291 :(
const p2pColors = {
    trip_requested: '#afafff',
    trip_confirmed: '#7171ff',
    trip_started: '#00ff00',
    trip_overdue: '#ff00ff',
    trip_returned: '#00b000',
    trip_returned_preliminary: '#00b000',
    trip_canceled: '#bfbfbf',
    trip_expired: '#bfbfbf',
    trip_rejected: '#bfbfbf'
};

// Will also be available as SCSS variables in the form $color_[key]
const cssDependentColors = {
    heatmap_orange: MATERIAL_COLORS.orange,
    heatmap_red: MATERIAL_COLORS.darkred,

    red: MATERIAL_COLORS.darkred,
    orange: MATERIAL_COLORS.orange,
    yellow: MATERIAL_COLORS.amber,
    red_light: MATERIAL_COLORS.red,
    green_light: MATERIAL_COLORS.green,

    bootstrap_btn_bg: cssColors.gray_whisper,
    bootstrap_btn_border: cssColors.gray_very_light,
    bootstrap_panel_heading_hover: cssColors.gray_snow,
    bootstrap_table_border: cssColors.gray_gainsboro,

    alerts_level_1: MATERIAL_COLORS.darkred,
    alerts_level_2: MATERIAL_COLORS.red,
    alerts_level_3: MATERIAL_COLORS.orange,
    alerts_level_4: MATERIAL_COLORS.amber,
    alerts_level_5: cssColors.gray
};

const COLORS = Object.freeze({ ...cssColors, ...cssDependentColors, ...p2pColors });
export {
    COLORS,
    MATERIAL_COLORS
};